export const moduleConfig = {
    entityKey: 'accounts'
}